export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = 'x-flag-exp'
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = 'x-flag-internal'

export const flags = {
  FLAG_FEAT_APP_SWITCHER_ENABLED: 'my-pga-com-feat-app-switcher-enabled',
  FLAG_FEAT_JRL_ENABLED: 'my-pga-com-feat-jrl-enabled',
  FLAG_FEAT_FC_PROGRAM_TEAMS_ENABLED: 'my-pga-com-feat-program-teams-enabled',
  FLAG_FEAT_FC_NEW_PAYMENT_SETTINGS_ENABLED:
    'my-pga-com-feat-fc-new-payment-settings-enabled',
  FLAG_FEAT_COACH_DISPLAY_LEAD_MODAL: 'my-pga-com-feat-lead-modal',
  FLAG_FEAT_COACH_EXCLUSIVE_BOOKING_CAPABILITY:
    'my-pga-com-feat-coach-exclusive-booking-capability',
  FLAG_FEAT_PAYMENT_ACCOUNT_MANAGEMENT:
    'my-pga-com-feat-payment-account-management',
  FLAG_FEAT_RESCHEDULE_LESSON: 'my-pga-com-feat-reschedule',
  FLAG_FEAT_REQUEST_TIME: 'my-pga-com-feat-request-time',
  FLAG_FEAT_WEBCAL: 'my-pga-com-feat-webcal',
  FLAG_MESSAGING_SERVICE: 'my-pga-com-and-mobile-messaging-service',
  FLAG_FEAT_ENABLE_ACTIVITY_PLANS: 'my-pga-com-feat-activity-plans',
  FLAG_FEAT_ENABLE_CUSTOM_PLANS: 'my-pga-com-feat-custom-plans',
  FLAG_LOCKED_LEADS_ENABLED: 'my-pga-com-feat-locked-leads',
  FLAG_AVG_RESPONSE_ENABLED: 'my-pga-com-feat-avg-response',
  FLAG_JRL_GO_LIVE: 'my-pga-com-feat-jrl-11-am-go-live',
  FLAG_FEAT_JRL_REG_GTM: 'my-pga-com-jrl-reg-gtm',
  FLAT_FEAT_STRIPE_FEE_DEDUCTED: 'my-pga-com-stripe-fee-deducted',
  FLAG_FEAT_LEAD_INTAKE_STEPPER_FORM: 'my-pga-com-feat-lead-intake-form',
  FLAG_EXPEDIED_SHIPPING_DISABLED: 'my-pga-com-jrl-expedited-shipping-disabled',
  FLAG_FEAT_XACT_ENABLE_SHOP_UPSERT: 'my-pga-com-xact-enable-shop-upsert',
  FLAG_FEAT_MESSAGING_ATTACHMENTS:
    'my-pga-com-and-mobile-messaging-attachments',
  FLAG_FEAT_LESSON_PACKS: 'my-pga-com-and-mobile-lesson-packs',
  FLAG_FEAT_BOOKING_START_TIMES:
    'my-pga-com-and-mobile-feat-booking-type-start-times',
  FLAG_FEAT_IDEAS_PAGE: 'my-pga-com-feat-ideas-page',
  FLAG_FEAT_EXTERNAL_REGISTRATION: 'my-pga-com-feat-external-registration-url',
  FLAG_FEAT_EXTERNAL_BOOKING_URL: 'my-pga-com-feat-external-booking-url',
  FLAG_FEAT_GROUP_EVENT_ACCESS_CODES:
    'my-pga-com-and-mobile-group-event-access-codes',
  FLAG_FEAT_EVENT_CREATION_REDESIGN: 'my-pga-com-feat-event-creation-redesign',
  FLAG_FEAT_GROUP_EVENT_RECURRING_PAYMENTS_ENABLED:
    'my-pga-com-feat-group-event-recurring-payments-enabled',
  FLAG_FEAT_SOFT_DELETE_LEADS: 'my-pga-com-and-mobile-feat-soft-delete-leads',
  FLAG_FEAT_CONVERT_LEAD_TO_STUDENT: 'my-pga-com-feat-convert-lead-to-student',
  FLAG_FEAT_STUDENT_SHOW_PAGE: 'my-pga-com-see-student-profile-page',
  FLAG_FEAT_COACH_OFFERING_REFRESH: 'my-pga-com-coach-offering-refresh',
  FLAG_STUDENT_REVENUE_STAT: 'my-pga-com-student-revenue-statistic',
  FLAG_STUDENT_MESSAGE_BUTTON: 'my-pga-com-message-student-button',
  FLAG_STUDENT_DETAILS_SESSIONS: 'my-pga-com-student-details-sessions',
  FLAG_REFUND_QUICK_ACTION: 'my-pga-com-refund-quick-action',
  FLAG_INTERCOM_BUTTON: 'my-pga-com-intercom-button',
  FLAG_COACH_ONBOARDING: 'my-pga-com-coach-onboarding-flow',
  FLAG_FACILITY_OFFERINGS: 'my-pga-com-new-profile-facility-offerings',
  FLAG_LIGHTNING_FAST_ONBOARDING: 'my-pga-com-lightning-fast-onboarding',
  FLAG_APP_INSTALL_BANNER_AD: 'my-pga-com-app-install-banner-ad',
  FLAG_FAMILY_GOLF_REBRAND: 'my-pga-com-family-golf-rebrand',
  FLAG_FEAT_COACH_QR_CODE: 'my-pga-com-qr-code',
  FLAG_NEW_LEADS_VIEW: 'my-pga-com-new-leads-table',
  FLAG_TIMEZONE_EVENT_BOOKING: 'my-pga-com-timezone-event-booking',
}
